export default {
    getDeletionErrorMessage(responseStatus, message) {
        if (responseStatus === 400) {
            message("Deletion failed. Please check the object you want to delete.");
        } else if (responseStatus === 401) {
            message("Deletion failed. Please check your authorization. Maybe you've been logged out.")
        } else if (responseStatus === 403) {
            message("Deletion failed. Insufficient rights for this action.");
        } else if (responseStatus === 404) {
            message("Deletion failed. The desired object was not found.");
        } else if (responseStatus === 409) {
            message("Deletion failed. You have a conflict in your data or violated a unique key.")
        } else {
            message("Deletion failed. Please contact the technical support.");
        }
    },

    getInsertErrorMessage(responseStatus, message) {
        if (responseStatus === 400) {
            message("Insert failed. Please check the object you want to create.");
        } else if (responseStatus === 401) {
            message("Insert failed. Please check your authorization. Maybe you've been logged out.")
        } else if (responseStatus === 403) {
            message("Insert failed. Insufficient rights for this action.");
        } else if (responseStatus === 404) {
            message("Insert failed. The desired object was not found.");
        } else if (responseStatus === 409) {
            message("Insert failed. You have a conflict in your data or violated a unique key.")
        } else {
            message("Insert failed. Please contact the technical support.");
        }
    },

    getUpdateErrorMessage(responseStatus, message) {
        if (responseStatus === 400) {
            message("Update failed. Please check the object you want to update.");
        } else if (responseStatus === 401) {
            message("Update failed. Please check your authorization. Maybe you've been logged out.")
        } else if (responseStatus === 403) {
            message("Update failed. Insufficient rights for this action.");
        } else if (responseStatus === 404) {
            message("Update failed. The desired object was not found.");
        } else if (responseStatus === 409) {
            message("Update failed. You have a conflict in your data or violated a unique key.")
        } else {
            message("Update failed. Please contact the technical support.");
        }
    }
}


// WEBPACK FOOTER //
// ./src/managers/errormessagemanager.js